import { Injectable, OnInit } from '@angular/core';
import { CanActivate,
         ActivatedRouteSnapshot,
         RouterStateSnapshot,
         Router} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class IsValidUrlGuard implements CanActivate {
  
  private isValidUrl: boolean = false;
  private baseUrl: string;

  constructor(private http: HttpClient, private router: Router, private appConfig: AppConfigService) {
    this.baseUrl = this.appConfig.getAppConfig().AppUrl;
  }
  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    LoaderService.showLoader();
    console.log(state);
      let url=state.url;
      console.log(this.router);
    return this.http.get(this.baseUrl + '/api/UserDataManager/IsValidUrl?url=' + url).pipe(map((response :IGetOperationResponse<boolean> )=> {
          if(response && response.Result){
           // LoaderService.hideLoader();
                    this.isValidUrl = true;
                    return this.isValidUrl;
          }else {
            LoaderService.hideLoader();
            this.router.navigateByUrl('/unauthorized'); 
              return false;
          }
        }),catchError(err=>{
          LoaderService.hideLoader()
          return of(false);
        }));
      }
  path: import("@angular/router").ActivatedRouteSnapshot[];    route: import("@angular/router").ActivatedRouteSnapshot;
  
}
